/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.content', {
            parent: 'board',
            url: '/board/content?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.content.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/content/contents.html',
                    controller: 'BoardContentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('content');
                    $translatePartialLoader.addPart('enumContentAccess');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.content.new', {
            parent: 'board.content',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/content/content-dialog.html',
                    controller: 'BoardContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                text: null,
                                access: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('board.content', null, { reload: 'board.content' });
                }, function() {
                    $state.go('board.content');
                });
            }]
        })
        .state('board.content.edit', {
            parent: 'board.content',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/content/content-dialog.html',
                    controller: 'BoardContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Content', function(Content) {
                            return Content.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.content', null, { reload: 'board.content' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.content.delete', {
            parent: 'board.content',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/content/content-delete-dialog.html',
                    controller: 'BoardContentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Content', function(Content) {
                            return Content.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.content', null, { reload: 'board.content' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
